import React, { useCallback, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

let _rid = 0;

// Button with a gold "spark" ripple that bursts from the click point.
// Forwards data-testid, onClick, disabled, type and className. Elite-only styling by default.
export default function GoldSparkButton({
  children,
  onClick,
  className = "",
  disabled = false,
  type = "button",
  sparkColor = "#D4AF37",
  spark = true,
  contentClass = "relative z-10 inline-flex items-center justify-center gap-2 w-full",
  ...rest
}) {
  const [ripples, setRipples] = useState([]);

  const handleClick = useCallback((e) => {
    if (disabled) return;
    if (spark) {
      const rect = e.currentTarget.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;
      const size = Math.max(rect.width, rect.height) * 1.6;
      const id = ++_rid;
      setRipples((prev) => [...prev, { id, x, y, size }]);
      setTimeout(() => setRipples((prev) => prev.filter((r) => r.id !== id)), 650);
    }
    onClick?.(e);
  }, [onClick, disabled, spark]);

  return (
    <motion.button
      type={type}
      disabled={disabled}
      whileTap={{ scale: 0.96 }}
      onClick={handleClick}
      className={`gold-spark ${className}`}
      {...rest}
    >
      <AnimatePresence>
        {ripples.map((r) => (
          <motion.span
            key={r.id}
            className="gold-spark-ripple"
            initial={{ opacity: 0.6, scale: 0 }}
            animate={{ opacity: 0, scale: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.6, ease: "easeOut" }}
            style={{ left: r.x, top: r.y, width: r.size, height: r.size, background: `radial-gradient(circle, ${sparkColor}bf 0%, ${sparkColor}40 40%, transparent 70%)` }}
          />
        ))}
      </AnimatePresence>
      <span className={contentClass}>{children}</span>
    </motion.button>
  );
}
